import { useEffect, useMemo } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export const SidebarMobile = () => {

  const navigate = useNavigate();
  const location = useLocation();

  useMemo(() => {
    (async () => {
      document.title = `ジョイン マイページ`
    })();
  }, []);

  useEffect(() => {
    if(location.pathname === "/portal" || location.pathname === "/portal/"){
      /** ルートディレクトリ遷移時 */
      navigate("eventParticipationMobile");
    }
  },[location.pathname, navigate]);

  return (
    <Outlet />
  );
};
